import React from 'react';
import {
  AuthMainContent,
  CopyRight,
} from '../page/index';

const layout = () => (
  <React.Fragment>
    <AuthMainContent />
    <CopyRight
      style={{
        position: 'absolute',
        bottom: '5px',
        width: '100%',
        color: '#000000',
      }}
    />
  </React.Fragment>
);

export default layout;



// WEBPACK FOOTER //
// ./src/components/layout/authLayout.js